<template>
	<AppDialog hideCloseButton disableMaxWidth :dialogName="'ChangeAccountOwnerDialog'" width="790px">
		<div class="dialog-content">
			<div class="display-flex flex-column flex-justify-space-between left width-100">
				<div class="title">Transfer workspace ownership</div>
				<div class="sub-title">You are changing the owner of workspace "{{ accountName }}"</div>
				<AppTextField
					class="pb-4"
					outlined
					dense
					v-model="typedAccountName"
					hide-details
					single-line
					label="Type your workspace name for confirmation"
				/>

				<AppSelect
					class="members pb-2"
					item-text="name"
					outlined
					dense
					v-model="selectedMember"
					:items="parsedMembers"
					return-object
					label="The owner will be..."
					@change="(v) => (selectedMember = v)"
				>
					<template v-slot:item="{ item }">
						<div class="flex-column option">
							<div class="name">{{ item.name }}</div>
							<div class="email">({{ item.email }})</div>
						</div>
					</template>
				</AppSelect>

				<div class="py-2">To transfer workspace ownership, accept the confirmation message that will be sent to you by email.</div>

				<div class="display-flex flex-centerize">
					<AnemicButton :disabled="isSending || !canChange" @click="change" tile class="yes-button pa-0">Send confirmation</AnemicButton>
					<AnemicButton :disabled="isSending" @click="cancel" tile class="no-button ml-3 pa-0">Cancel</AnemicButton>
				</div>
				<div class="pt-2 px-4 error-text" v-if="isError">{{ error }}</div>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { sendChangeAccountOwnerMail } from '@/store/modules/account/actions';
import { account } from '@/store/modules/account/getters';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import ErrorHandlingService from '@/utils/error-handling-service';
import { DIALOG_RESPONSES } from '@/components/dialogs/AppDialogs/app-dialog.const';

export default {
	name: 'ChangeAccountOwnerDialog',
	components: {
		AppDialog,
	},
	props: {
		members: { type: Array },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		...mapGettersShorthand({ account }),
		accountName() {
			return this.account.name;
		},
		canChange() {
			return this.typedAccountName == this.accountName;
		},
		parsedMembers() {
			return this.members.map((x) => ({ ...x, name: x.name || x.email }));
		},
	},
	methods: {
		...mapActionsShorthand({ sendChangeAccountOwnerMail }),
		close(res) {
			this.dialogPromiseHandlers.resolve(res);
			AppDialogManagerService.closeCurrentDialog();
		},
		cancel() {
			this.close();
		},
		clearError() {
			this.isError = false;
			this.error = '';
		},
		async change() {
			if (!this.canChange) {
				return;
			}

			this.isError = false;
			this.isSending = true;
			try {
				await this.sendChangeAccountOwnerMail({ userAccountId: this.selectedMember.id });
				this.close(DIALOG_RESPONSES.CHANGE);
			} catch (err) {
				const msg = ErrorHandlingService.extractErrorMessage(err) || 'something went wrong';
				this.isError = true;
				this.error = msg;
			}
			this.isSending = false;
		},
	},
	watch: {
		selectedMember: {
			handler() {
				this.clearError();
			},
		},
	},
	data() {
		return {
			selectedMember: null,
			typedAccountName: null,
			error: '',
			isError: false,
			isSending: false,
		};
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	height: 380px;
	background: var(--white);
}

.rounded {
	border-radius: 10px;
}
.left {
	padding: 64px 34px;
}
.right {
	width: 270px;
	padding: 80px 16px;
	background: #f9fafc;
}
.header-text {
	font-size: 25px;
	color: var(--primary-font-color);
}
.footer-button {
	width: 170px !important;
	height: 40px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
}
.yes-button {
	@extend .footer-button;
	color: #ffffff !important;
	background: #5858ec !important;
}
.no-button {
	@extend .footer-button;
	color: #5858ec !important;
	background: #ffffff !important;
	border: 1px solid #5858ec !important;
}
.option {
	font-size: 12px;
	.name {
	}
	.email {
		font-size: 11px;
		opacity: 0.5;
	}
}
.error-text {
	font-size: 12px;
	color: red;
}
</style>
